"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var reducers = {
    subscriptions: api_1.createApiModuleReducer({
        actionType: constants_1.FETCH_USER_SUBSCRIPTIONS,
        onSuccess: api_1.createApiOnSuccessReducer(function (_, action) {
            var _a, _b;
            return (_b = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.subscriptions;
        }),
    }, []),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map